
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 20 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1273_35831)","fill":"#A6ADB5"}},[_c('path',{attrs:{"d":"M15.125 16.067a.936.936 0 01-.663-.275l-2.812-2.813a.937.937 0 011.325-1.325l2.813 2.812a.937.937 0 01-.663 1.6z"}}),_c('path',{attrs:{"d":"M8.796 14.654a5.859 5.859 0 115.748-7 5.857 5.857 0 01-5.748 7zm0-9.839a3.983 3.983 0 10.005 7.965 3.983 3.983 0 00-.005-7.965z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1273_35831"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(2 2)","d":"M0 0h15v15H0z"}})])])])
          )
        }
      }
    